import React, { useEffect, useState } from 'react';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { fonts } from '../../themes/themes';
interface ICustomRadioProps {
  defaultData?: any;
  name?: string;
  label?: string;
  options?: Array<object>;
  style?: React.CSSProperties;
  fontSize?: string;
  setValue?: (answerOptionId: any) => void;
  existOption?: string;
}

function CustomRadioButton({
  defaultData,
  name,
  label,
  options,
  style,
  fontSize,
  setValue,
  existOption,
}: ICustomRadioProps) {
  const StyledFormControl = styled(FormControl)({
    '& .muiltr-vqmohf-MuiButtonBase-root-MuiRadio-root.Mui-checked': {
      color: '#7B0E6E',
    },
    '& .muiltr-ahj2mt-MuiTypography-root ': {
      fontSize: fontSize,
    },
  });

  const [data, setData] = useState(existOption);

  const handleChange = (event: any) => {
    setData(event.target.value);
    const selectData = options?.find(
      (item: any) => item?.id === event?.target?.value,
    );
    if (selectData) {
      setValue?.(selectData);
    }
  };

  return (
    <StyledFormControl>
      <FormLabel id="common-radio-buttons">{label}</FormLabel>
      <RadioGroup
        defaultValue={defaultData}
        name={name}
        value={data}
        style={{ fontFamily: 'lato' }}
        onChange={handleChange}
      >
        {options &&
          options.map((option: any, index: number) => (
            <FormControlLabel
              key={index}
              control={<Radio />}
              label={option.title}
              value={option.id}
              style={style}
            />
          ))}
      </RadioGroup>
    </StyledFormControl>
  );
}
export default CustomRadioButton;
